module.exports = __webpack_public_path__ + "static/media/amarant-3.50ab7081.png";